import React from 'react';

import {IBbbeeSubStepProps} from '../companyDetails.types';

const BbbeeSubStep: React.FC<IBbbeeSubStepProps> = ({
  bbbeeOptions,
  bbbeeLevel,
  onBbbeeLevelChange,
}) => (
  <div className="company-bbbee-list">
    {bbbeeOptions.length === 0 ? (
      <div className="company-info-panel">
        <p>
          No B-BBEE options are available on this profile yet. Refresh data and
          try again.
        </p>
      </div>
    ) : (
      bbbeeOptions.map((option) => (
        <label
          key={option.value}
          className={`company-bbbee-option${
            bbbeeLevel === option.value ? ' is-selected' : ''
          }`}
        >
          <input
            type="radio"
            name="bbbeeLevel"
            value={option.value}
            checked={bbbeeLevel === option.value}
            onChange={(event) => onBbbeeLevelChange(event.target.value)}
          />
          <span>{option.label}</span>
        </label>
      ))
    )}
  </div>
);

export default BbbeeSubStep;

export {BbbeeSubStep};
